<template>
  <div class="preamble">
    <div
      class="preamble__wrapper"
      :class="`preamble__alignment-${align}`"
    >
      <div
        v-if="prefix || isEditable"
        v-edit="'Prefix'"
        class="preamble__prefix"
      >
        {{ prefix }}
      </div>
      <h1
        v-if="title || isEditable"
        v-edit="'Title'"
        class="preamble__heading"
      >
        {{ title }}
      </h1>
      <p
        v-if="preamble || isEditable"
        v-edit="'Preamble'"
        class="preamble__text"
      >
        {{ preamble }}
        <slot
          name="preamble-link"
        />
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PreambleBlock",
    props: {
      prefix: {
        type: String,
        default: ""
      },
      title: {
        type: String,
        default: ""
      },
      preamble: {
        type: String,
        default: ""
      },
      align: {
        type: String,
        default: "center"
      }
    }
  }
</script>

<style lang="scss">
  .preamble {
    $this: &;

    &__wrapper {
      margin: 0 0 1.5rem;
      text-align: center;
      padding: 0 2rem;

      @include media-breakpoint-up(md) {
        margin: 0 0 3rem 0;
        padding: 0;
      }
    }

    &__alignment-left {
      text-align: left;
    }

    &__prefix {
      color: $color-red;
      margin-bottom: 1rem;

      @include font(hand,2, "normal");
    }

    &__heading {
      margin: 0 0 1rem 0;

      @include font(rubrik,7, "black");
    }

    &__text {
      @include font(text,5, "light");

      margin: 0.5rem 0;
    }

    @include media-breakpoint-down(md) {
      .wrap-container > & .preamble__wrapper,
      .wrap-container > .row > & .preamble__wrapper {
        padding: 0;
        margin-bottom: 2.125rem;
      }
    }
  }
</style>
